import(/* webpackMode: "eager", webpackExports: ["UpgradeBanner"] */ "/home/runner/work/agentx/agentx/apps/web/app/discover/upgrade-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteFooter"] */ "/home/runner/work/agentx/agentx/apps/web/components/SiteFooter.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/agentx/agentx/node_modules/.pnpm/next@15.0.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
